'use es6';

import { Set as ImmutableSet } from 'immutable';
import { userInfo } from '../../request/user-info';
import { NO_ID, MY_USER_ID } from '../../constants/magicTypes';
export default ((config, paths = ImmutableSet()) => userInfo().then(({
  user: {
    user_id: userId = NO_ID
  } = {}
}) => paths.reduce((memo, path) => memo.updateIn(['filters', ...path], value => value === MY_USER_ID ? userId : NO_ID), config)));